module.exports = __webpack_public_path__ + "static/media/MOTIVATION_INT.4265ef29.md";